/* Galaxy cart pricing for the theme (replaces Hulk Discounts on the page). Same maths as the order server's pricing.py:
   the server re-prices every checkout and refuses (409) if the page total differs, so both must agree to the cent.
   Works in whole cents:
     percent tier -> line discount = line total x percent, rounded DOWN to the cent
     fixed price  -> per unit: line = quantity x tier price
   A decoration (fixed-price) rule beats the bulk percent whenever it matches the line, even below its first tier.
   Rules come from the shop metafield gaau.pricing_rules (window.GAAU_RULES). Tested against the shared test carts
   with node (tests_pricing_js.js). */
(function (root) {
  'use strict';

  function cents(value) { return Math.round(parseFloat(value) * 100); }

  function tier(tiers, qty) {
    var best = null;
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i][0]) best = tiers[i][1]; }
    return best;
  }

  function fixedRule(rules, line) {
    for (var i = 0; i < rules.fixed.length; i++) {
      var r = rules.fixed[i];
      if (r.handle !== line.handle) continue;
      if (r.variant_starts && (line.variant_title || '').indexOf(r.variant_starts) !== 0) continue;
      return r;
    }
    return null;
  }

  /* lines: [{handle, product_id, variant_id, variant_title, unit_price (cents), quantity}]
     returns one result per line: {kind: none|percent|fixed|fixed_first_tier, value, unit, original, total, discount} */
  function priceLines(lines, rules) {
    var perProduct = {}, perVariant = {};
    lines.forEach(function (l) {
      perProduct[l.product_id] = (perProduct[l.product_id] || 0) + l.quantity;
      perVariant[l.variant_id] = (perVariant[l.variant_id] || 0) + l.quantity;
    });
    return lines.map(function (l) {
      var unit = l.unit_price, original = unit * l.quantity;
      var out = {kind: 'none', value: null, unit: unit, original: original, total: original};
      var rule = fixedRule(rules, l);
      if (rule) {
        var count = rule.count === 'per_variant' ? perVariant[l.variant_id] : perProduct[l.product_id];
        var price = tier(rule.tiers, count);
        if (price !== null && cents(price) < unit) {
          out.kind = 'fixed'; out.value = cents(price); out.total = cents(price) * l.quantity;
        } else if (price !== null) {
          out.kind = 'fixed_first_tier';
        }
      } else {
        var pct = tier(rules.bulk.tiers, perProduct[l.product_id]);
        if (pct) {
          out.kind = 'percent'; out.value = pct; out.total = original - Math.floor(original * pct / 100);
        }
      }
      out.discount = original - out.total;
      return out;
    });
  }

  /* Setup fee for one logo line (quantity 1), in cents. choice: the 'Logo setup' value. */
  function setupFee(rules, handle, choice) {
    var h = rules.setup_fees[handle], fee = h && h.fees && h.fees[choice];
    return fee ? cents(fee.price) : 0;
  }

  /* Same minimums as the server's check_options. lines need handle, title, quantity, properties. */
  function minimumProblems(rules, lines) {
    var problems = [], perProduct = {};
    lines.forEach(function (l) {
      var m = rules.minimums[l.handle];
      if (!m) return;
      if (m.per === 'logo_line' && l.quantity < m.qty) {
        problems.push(l.title + ' (' + ((l.properties || {}).Position || 'no position') + '): minimum ' + m.qty +
                      ' per logo, this line has ' + l.quantity + '.');
      }
      if (m.per === 'product') {
        perProduct[l.handle] = perProduct[l.handle] || {title: l.title, qty: 0};
        perProduct[l.handle].qty += l.quantity;
      }
    });
    Object.keys(perProduct).forEach(function (h) {
      if (perProduct[h].qty < rules.minimums[h].qty) {
        problems.push(perProduct[h].title + ': minimum ' + rules.minimums[h].qty + ', the cart has ' + perProduct[h].qty + '.');
      }
    });
    return problems;
  }

  var api = {cents: cents, priceLines: priceLines, setupFee: setupFee, minimumProblems: minimumProblems};
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.GaauPricing = api;
})(this);
